import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import type { CreateComments } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { Observable, map, catchError, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {
  private http = inject(HttpClient);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  
  CreateTaskComment(tenantId: number, taskId: number, comments:CreateComments): Observable<any> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.COMMENTS.CREATE_TASK_COMMENT
      .replace('{tenant_id}', tenantId.toString())
      .replace('{task_id}', taskId.toString()), comments, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
        , catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError());
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  DeleteTaskComment(tenantId: number, taskId: number, commentId:number): Observable<any> {
    return this.http.delete(environment.BASE_URL + CONST_URL_SEGEMENTS.COMMENTS.DELETE_TASK_COMMENT
      .replace('{tenant_id}', tenantId.toString())
      .replace('{task_id}', taskId.toString())
      .replace('{comment_id}', commentId.toString()), this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        })
        , catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError());
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
